import Container from '@mui/material/Container'
import { styled } from '@mui/material/styles'

const StyledContainer = styled(Container)(({ theme }) => ({
    paddingLeft: theme.spacing(6),
    paddingRight: theme.spacing(6),
    [theme.breakpoints.up('sm')]: {
        paddingLeft: theme.spacing(4),
        paddingRight: theme.spacing(4),
    },
    [theme.breakpoints.up('lg')]: {
        paddingLeft: theme.spacing(21.25),
        paddingRight: theme.spacing(21.25),
    },
    marginTop: theme.spacing(4),
    backgroundColor: 'white',
    height: '100%',
    paddingTop: theme.spacing(6),
}))

export default StyledContainer
